/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.8.27",
    versionName: "0.2.0-nightly.2025.8.27",
    versionChannel: "nightly",
    buildDate: "2025-08-27T00:07:29.494Z",
    commitHash: "9477c10e4846c11ef0e24cc99fbc0805f9002cb7",
};
